import httpClient from "../axiosBase/axiosHandler";

export const createSupplier = (data) => {
  return httpClient.post("/suppliers/", data);
};

export const updateSupplier = ({ data, id }) => {
  return httpClient.patch(`/suppliers/${id}/`, data);
};

export const getSuppliers = (queries = "", queryParams = {}) => {
  return httpClient.get(`/suppliers/${queries}`, {
    params: { per_page: 300, ...queryParams },
  });
};

export const getSuppliersDetails = (id) => {
  return httpClient.get(`/suppliers/${id}/`);
};

export const deleteSupplier = ({ id }) => {
  return httpClient.delete(`/suppliers/${id}/`);
};

export const addMultipleSuppliers = (data) => {
  return httpClient.post("/suppliers/bulk-create/", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
